import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { TerminalVersion } from '../version.constant';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  private _version$: BehaviorSubject<string> = new BehaviorSubject<string>(
    'unknown'
  );

  constructor(private httpClient: HttpClient) {
    this._version$.next(TerminalVersion);
  }

  public get() {
    return this._version$.asObservable();
  }

  public isCurrentVersion(): Observable<boolean> {
    return this._version$
      .asObservable()
      .pipe(
        switchMap((currentVersion) =>
          this.httpClient
            .get<{ version: string }>('./version.json')
            .pipe(map((res) => res.version === currentVersion))
        )
      );
  }
}
